import { useEffect, useState } from 'react';

const DEFAULT_BREAKPOINT = 640;

export function useCompactLayout(maxWidth: number = DEFAULT_BREAKPOINT) {
    const [isCompact, setIsCompact] = useState(() => (typeof window !== 'undefined' ? window.innerWidth <= maxWidth : false));

    useEffect(() => {
        const handleResize = () => setIsCompact(typeof window !== 'undefined' ? window.innerWidth <= maxWidth : false);

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [maxWidth]);

    return isCompact;
}
